module.exports = __webpack_public_path__ + "fonts/WorkSans-Light.3d407fc.eot";